// extracted by mini-css-extract-plugin
var _1 = "ClampingTextButtonTail-modulecontainer__iCE0W";
export { _1 as "container" }
